module.exports = __webpack_public_path__ + "static/media/madball-logo@2x.50da380c.png";